module.exports = __webpack_public_path__ + "img/poker-s05.020a8f3e.svg";